import React, {useEffect, useRef, useState} from 'react';
import {
  View,
  TouchableOpacity,
  Text,
  StyleSheet,
  FlatList,
  Linking,
  Dimensions,
  ActivityIndicator,
  ScrollView,
} from 'react-native';
import {useDispatch, useSelector, connect} from 'react-redux';
import {Color, globalFontStyle, globalStyle} from '../../assets';
import Header from '../../commonComponents/Header';

import {
  getLoginRoute,
  isMobile,
  trackMoengageEvent,
} from '../../utils/commonMethods';
import NoMarket from '../../commonComponents/NoMarkets';
import HomeBanners from '../home/childComponents/homeBanners';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {Network} from '../../utils/network';
import Colors from '../../assets/Color/Colors';
import ContestCard from './childComponents/ContestCard';
import {
  getContestClose,
  getContestCoinsBalance,
  getContestLive,
  removeContest,
} from './redux/contest.action';
import {useFocusEffect} from '@react-navigation/native';
import {globalImport} from '../../common/globalImports';
import CommonModal from '../../commonComponents/commonModal';
import HowToTradeVideo from '../home/childComponents/howToTradeVideo';
import {contestDummyBanners} from '../home/home.constant';
import {globalConst} from '../../utils/globalConstant';
import {RefreshControl} from 'react-native-web-refresh-control';
import ContestOnBoarding from '../../commonComponents/ContestOnBoarding';
import {
  contest_play,
  contest_smiley,
  contest_trophy,
  discord,
  smile_coin,
} from '../../utils/images';
import FormTextLabel from '../../commonComponents/FormTextLabel';
import Width from '../../assets/Width';
import FastImage from '../../common/FastImage';
import ContestTab from './childComponents/ContestsTab';
import RewardsEvents from '../rewards/childComponents/rewardsEvents';
import CoinsBottomSheet from '../home/childComponents/CoinsBottomSheet';
import {setFirstLogin} from '../Login/redux/login.action';
import Gamification from '../rewards/childComponents/gamification';
import {Toast} from 'react-native-toast-message/lib/src/Toast';
import {convert} from '../../locale/translateText';

const Contest = ({route, navigation}) => {
  const isContestTab = route?.params?.isContest;
  const isFirstLogin = useSelector(state => state.login.isStoreFirstLogin);
  const [isEventsSelected, setIsEventsSelected] = useState(!isContestTab);
  const [coinModalVisible, setCoinModalVisible] = useState(false);
  const [rewardsDetail, setRewardDetail] = useState(null);

  useFocusEffect(
    React.useCallback(() => {
      setIsEventsSelected(isContestTab === 'true' ? false : true);
    }, [isContestTab]),
  );

  const isContestVisible = useSelector(
    state => state.contestLeaderboardReducer.isContestVisible,
  );

  const contestConfig = useSelector(
    state => state.utilReducer.globalConfigData?.contestConfig,
  );
  let userInfo = useSelector(({profile}) => profile.profileData);
  const isAppLogin = useSelector(({utilReducer}) => utilReducer.isAppLogin);
  const insets = useSafeAreaInsets();
  const [modalVisible, setModalVisible] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isMobile() && userInfo?.promo_message?.title && isFirstLogin) {
      setCoinModalVisible(isFirstLogin);
      dispatch(setFirstLogin(false));
    }
  }, [isFirstLogin, userInfo]);

  const onCoinModal = value => {
    setCoinModalVisible(value);
  };

  const onLearnMore = () => {
    setModalVisible(!modalVisible);
  };

  const showToast = () => {
    Toast.show({
      type: 'info',
      text1: '100 tokens required for creating an event',
      visibilityTime: 2000,
      position: 'bottom',
    });
  };

  const HeaderComponent = () => {
    return (
      <>
        {/*<HomeBanners*/}
        {/*  screen="contest"*/}
        {/*  globalConfigData={globalConfigData}*/}
        {/*  onLearnMore={onLearnMore}*/}
        {/*/>*/}
        <FormTextLabel
          labelStyles={{
            ...globalFontStyle.appBlueHead,
            color: Colors.black,
            paddingVertical: 20,
          }}
          label={'Trade in events/contest with Token Points to '}>
          <FormTextLabel
            labelStyles={{color: Colors.tradexBlue}}
            label={'earn more!'}
          />
        </FormTextLabel>
        {(!isAppLogin || userInfo?.coinsp !== undefined) && (
          <View
            style={{
              marginBottom: 15,
              borderRadius: 8,
              borderWidth: 0.75,
              width: Width.width - 32,
              borderColor: Colors.borderColor,
            }}>
            <View style={styles.rewardsBox}>
              <FastImage
                style={{width: 28, height: 28}}
                source={smile_coin()}
              />
              <View
                style={{
                  marginHorizontal: 15,
                  flex: 1,
                  justifyContent: 'space-between',
                }}>
                <FormTextLabel
                  labelStyles={{
                    ...globalFontStyle.appFontTitle,
                    color: Colors.black,
                  }}
                  label={
                    isAppLogin
                      ? userInfo?.coinsp?.toFixed(2)
                      : 'Get 2500 Tokens'
                  }
                />

                {/* {isAppLogin ? (
                  <FormTextLabel
                    labelStyles={{
                      ...globalFontStyle.appFontSmallText,
                      color: Colors.lightgrey,
                    }}
                    label={'1 Token = '}>
                    <Text
                      style={{
                        ...globalFontStyle.appFontSmallTextBold,
                        color: Colors.black,
                      }}>
                      ${userInfo?.luckyCoins?.exchange_rate?.USDT}
                    </Text>
                  </FormTextLabel>
                ) : null} */}
                {/* <Text
                style={{
                  ...globalFontStyle.appFontSmallText,
                  color: Colors.lightgrey,
                }}>
                1 Lucky coin = {userInfo?.luckyCoins?.exchange_rate?.USDT} USDT
              </Text> */}
              </View>
              <View style={{justifyContent: 'center'}}>
                {isAppLogin ? (
                  <>
                    <FormTextLabel
                      onPress={() =>
                        navigation.navigate('RewardsStack', {screen: 'Rewards'})
                      }
                      labelStyles={{
                        ...styles.headerOptionsContest,
                        backgroundColor: 'rgba(0,0,0,0.03)',
                        borderColor: Colors.borderColor,
                        borderWidth: 0.75,
                      }}
                      label={'View Details'}
                    />
                  </>
                ) : (
                  <FormTextLabel
                    onPress={() => navigation.navigate(getLoginRoute())}
                    labelStyles={{
                      ...styles.headerOptionsContest,
                      backgroundColor: Colors.tradexBlue,
                      borderWidth: 0,
                      color: Colors.bgWhite,
                    }}
                    label={'Sign Up'}
                  />
                )}
              </View>
            </View>

            {userInfo?.luckyCoins?.note_string && (
              <View style={styles.lcBlock}>
                <FormTextLabel
                  label={'Note -'}
                  labelStyles={globalFontStyle.appFontSubHeading}>
                  <Text style={globalFontStyle.appFontBody}>
                    {' ' + userInfo?.luckyCoins?.note_string}
                  </Text>
                </FormTextLabel>
              </View>
            )}
          </View>
        )}
        <Gamification />
        <View
          style={[
            {
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 15,
              backgroundColor: 'rgba(244, 244, 244, 1)',
              borderRadius: 8,
              paddingVertical: 3,
              paddingHorizontal: 6,
            },
          ]}>
          <TouchableOpacity
            onPress={() => setIsEventsSelected(true)}
            style={
              isEventsSelected
                ? styles.headerOptionsSelected
                : styles.headerOptions
            }>
            <FormTextLabel
              labelStyles={
                isEventsSelected
                  ? {...globalFontStyle.appFontHeading, color: Colors.black}
                  : {
                      ...globalFontStyle.appFontHeadingRegular,
                      color: Colors.lightgrey,
                    }
              }
              label={'Events'}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => setIsEventsSelected(false)}
            style={
              !isEventsSelected
                ? styles.headerOptionsSelected
                : styles.headerOptions
            }>
            <FormTextLabel
              labelStyles={
                !isEventsSelected
                  ? {...globalFontStyle.appFontHeading, color: Colors.black}
                  : {
                      ...globalFontStyle.appFontHeadingRegular,
                      color: Colors.lightgrey,
                    }
              }
              label={'Contests'}
            />
            <Text>{'        '}</Text>
            <View style={{position: 'absolute', top: 1, right: 12}}>
              <FastImage
                style={{width: 50, height: 28}}
                source={contest_play()}
              />
            </View>
          </TouchableOpacity>
        </View>
        {userInfo?.create_event_enabled ? (
          <TouchableOpacity
            style={styles.stripeCreate}
            onPress={() =>
              userInfo?.create_event_clickable
                ? navigation.navigate('RewardsStack', {
                    screen: 'EventCreate',
                  })
                : showToast()
            }>
            <Text
              style={[
                globalFontStyle.appFontSubTextBold,
                {color: Colors.tradexBlue},
              ]}>
              + Create your own event
            </Text>
          </TouchableOpacity>
        ) : null}
      </>
    );
  };

  const onDiscordClick = () => {
    Linking.openURL(
      contestConfig?.discordLink
        ? contestConfig?.discordLink
        : 'https://discord.com/invite/5PjgUuVQ',
    );
  };

  const handleEmpty = () => {
    return <NoMarket source="contest" />;
  };

  return (
    <>
      {isContestVisible ? (
        <View
          style={[
            {
              backgroundColor: Color.bgWhite,

              paddingTop: insets.top,
              //paddingBottom: insets.bottom,
              paddingLeft: insets.left,
              paddingRight: insets.right,
            },
            isMobile() ? globalStyle.scroll_webFix : {},
          ]}>
          <ScrollView
            contentContainerStyle={{flexGrow: 1}}
            keyboardShouldPersistTaps="handled"
            nestedScrollEnabled={true}>
            {isMobile() && (
              <Header
                isInternalPage={false}
                navigation={navigation}
                pageName={'Tokens'}
                backGroundColor={'#FFFFFF'}
                isShowBackIcon={false}
                httTitle={convert('Join Discord')}
                isLeftImage={discord}
                onHTTClick={onDiscordClick}
                translate={true}
                customHeaderText={{
                  ...globalFontStyle.appBlueHead,
                  marginLeft: 0,
                }}
              />
            )}
            <View style={{flex: 1, paddingHorizontal: 16}}>
              <HeaderComponent />

              {!isEventsSelected ? (
                <ContestTab isAppLogin={isAppLogin} />
              ) : (
                <RewardsEvents navigation={navigation} />
              )}
            </View>
            <CommonModal
              onModalCallBack={() => {
                onCoinModal(false);
              }}
              showModal={coinModalVisible}
              customModalStyle={[
                globalStyle.modalView,
                {alignItems: 'stretch', paddingTop: 0},
              ]}>
              <CoinsBottomSheet
                onBottomSheetClose={() => {
                  onCoinModal(false);
                }}
                promoData={userInfo?.promo_message}
                isSignUP={true}
              />
            </CommonModal>
            <CommonModal
              onModalCallBack={onLearnMore}
              showModal={modalVisible}
              customModalStyle={[
                globalStyle.modalView,
                {alignItems: 'stretch'},
              ]}>
              <HowToTradeVideo
                onLearnMore={() => {
                  setTimeout(() => {
                    onLearnMore();
                  }, globalConst?.buttonTimer);
                }}
                isContest={true}
                hTTVideoKey={
                  globalImport.isWeb
                    ? contestConfig?.howItWorks?.videoWeb ||
                      contestDummyBanners[0]?.linkWeb
                    : contestConfig?.howItWorks?.videoApp ||
                      contestDummyBanners[0]?.link
                }
              />
            </CommonModal>
          </ScrollView>
        </View>
      ) : (
        <ContestOnBoarding />
      )}
    </>
  );
};

// const mapStateToProps = ({ contestLeaderboardReducer }) => ({
//   liveData: contestLeaderboardReducer.liveData,
//   closeData: contestLeaderboardReducer.closeData,
//   contestCardsLoading: contestLeaderboardReducer.contestCardsLoading,
// });
// const mapDispatchToProps = {
//   getContestClose,
//   getContestLive,
//   removeContest,
// };

export default Contest;

const styles = StyleSheet.create({
  headerOptions: {
    ...globalFontStyle.appFontHeadingRegular,
    color: Colors.lightgrey,
    paddingVertical: 6,
    textAlign: 'center',
    flex: 1,

    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  headerOptionsSelected: {
    ...globalFontStyle.appFontHeading,
    color: Colors.black,
    paddingVertical: 6,
    backgroundColor: Colors.bgWhite,
    borderRadius: 12,
    textAlign: 'center',
    flex: 1,
    shadowColor: '#000',
    shadowOffset: {
      width: 1,
      height: 1,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3,
    elevation: 2,

    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  headerOptionsContest: {
    ...globalFontStyle.appFontBody,
    color: Colors.black,
    alignItems: 'center',
    borderRadius: 100,
    justifyContent: 'center',
    textAlign: 'center',
    paddingHorizontal: 15,
    borderColor: Color.borderColor,
    borderWidth: 1,
    paddingVertical: 8,
  },
  headerOptionsSelectedContest: {
    ...globalFontStyle.appFontBody,
    color: Colors.bgWhite,
    alignItems: 'center',
    borderRadius: 100,
    justifyContent: 'center',
    textAlign: 'center',
    paddingHorizontal: 15,
    borderColor: Color.black,
    borderWidth: 1,
    paddingVertical: 8,
    backgroundColor: Colors.black,
  },
  proTraderButton: {
    flex: 0,
    backgroundColor: Colors.bgWhite,
    borderColor: Colors.black,
    paddingHorizontal: 10,
    borderRadius: 16,
    borderWidth: 0.5,
    paddingVertical: 5,
    flexDirection: 'row',
  },
  rewardsBox: {
    alignSelf: 'flex-start',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    paddingHorizontal: 15,
    paddingVertical: 12,
    width: Width.width - 32,
  },
  lcBlock: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 15,
    paddingVertical: 6,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    backgroundColor: 'rgba(251, 188, 5, 0.1)',
  },
  stripeCreate: {
    paddingVertical: 12,
    borderWidth: 1,
    borderColor: Color.tradexBlue,
    alignItems: 'center',
    borderStyle: 'dashed',
    marginBottom: 15,
    marginTop: 5,
    borderRadius: 5,
    backgroundColor: 'rgba(10, 87, 255, 0.10)',
  },
});
